import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/vercel/path0/web/layouts/default.vue").then(m => m.default || m)),
  marketing: defineAsyncComponent(() => import("/vercel/path0/web/layouts/marketing.vue").then(m => m.default || m)),
  "simple-brand": defineAsyncComponent(() => import("/vercel/path0/web/layouts/simple-brand.vue").then(m => m.default || m))
}